export default function formatCurrency(value: number) {
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  })
}



// WEBPACK FOOTER //
// ./src/components/shared/formatCurrency.ts